<template>
  <footer
    :class="[
      isDesktop ? 'isDesktop' : '',
      isLaptop ? 'isLaptop' : '',
      isTablet ? 'isTablet' : '',
      isMobile ? 'isMobile' : '',
    ]"
    class="footer"
  >
    <div class="overlay" />
    <div class="footer-container">
      <!-- Left Section -->

      <img src="/images/logoFooter.png" alt="Logo" />
      <!-- Center Section -->
      <div class="footer-center">
        <h4>תמיכה ושירות לקוחות</h4>
        <div class="foter-center-continer">
          <div class="contact-info">
            <!-- <div @click="openWaze">
              <v-icon color="white" icon="mdi-waze"></v-icon>
              <span>קריית גת, הנשיא 1</span>
            </div>
            <span v-if="isDesktop || isLaptop">|</span> -->
            <div>
              <v-icon color="white" icon="mdi-phone"></v-icon>
              <span @click="makePhoneCall('0524661378')">052-4661378</span>
              <span @click="makePhoneCall('0506665638')">050-6665638</span>
            </div>
            <span v-if="isDesktop || isLaptop">|</span>
            <div @click="sendEmail">
              <v-icon color="white" icon="mdi-email-outline"></v-icon>
              <span>rgift494@gmail.com</span>
            </div>
          </div>
          <div class="more-contact">
            <span v-if="isDesktop || isLaptop">|</span>
            <a @click="openAnyDesk" class="footer-link"
              >השתלטות מרחוק Anydesk
            </a>
            <span>|</span>
            <a href="/policy" class="footer-link">מדיניות האתר</a>
            <span>|</span>
            <a href="/about" class="footer-link">קצת עלינו</a>
          </div>
        </div>
        <div class="footer-badges">
          <div class="secure-badge">
            <v-icon size="16" color="#4CAF50">mdi-lock</v-icon>
            <span>תשלום מאובטח</span>
          </div>
          <div class="payment-icons">
            <svg class="payment-icon" viewBox="0 0 48 32" xmlns="http://www.w3.org/2000/svg">
              <rect width="48" height="32" rx="4" fill="#1A1F71" />
              <text x="24" y="20" text-anchor="middle" fill="#fff" font-size="12" font-weight="bold" font-family="Arial">VISA</text>
            </svg>
            <svg class="payment-icon" viewBox="0 0 48 32" xmlns="http://www.w3.org/2000/svg">
              <rect width="48" height="32" rx="4" fill="#f5f5f5" stroke="#e0e0e0"/>
              <circle cx="19" cy="16" r="10" fill="#EB001B" opacity="0.8"/>
              <circle cx="29" cy="16" r="10" fill="#F79E1B" opacity="0.8"/>
            </svg>
            <svg class="payment-icon" viewBox="0 0 48 32" xmlns="http://www.w3.org/2000/svg">
              <rect width="48" height="32" rx="4" fill="#f5f5f5" stroke="#e0e0e0"/>
              <text x="24" y="20" text-anchor="middle" fill="#2557D6" font-size="8" font-weight="bold" font-family="Arial">AMEX</text>
            </svg>
            <div class="ssl-badge">
              <v-icon size="12" color="#4CAF50">mdi-shield-check</v-icon>
              <span>SSL</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Right Section -->
      <div class="d-flex flex-column align-center mt-4">
        <img class="dolimo-logo" :src="dolimoLogo" alt="" />
        <div class="version">v{{ config.version }}</div>
      </div>
    </div>
  </footer>
</template>

<script>
import { mapGetters } from "vuex";
import config from "../../config";

export default {
  computed: {
    dolimoLogo() {
      return "/images/לוגו-משו-ענק-וגם-לבן.png";
    },
    config() {
      return config;
    },
    ...mapGetters({
      isMobile: "isMobile",
      isLaptop: "isLaptop",
      isTablet: "isTablet",
      isDesktop: "isDesktop",
    }),
  },
  methods: {
    openWaze() {
      // Waze deep link to the specified address
      const wazeUrl = `https://waze.com/ul?q=${encodeURIComponent(
        "קריית גת, הנשיא 1"
      )}`;
      this.openExternalLink(wazeUrl);
    },
    makePhoneCall(phoneNumber) {
      // Use tel: protocol to initiate phone call
      // window.location.href = "tel:089898766";
      window.location.href = `tel:${phoneNumber}`;
    },
    sendEmail() {
      // Use mailto: protocol to open default email client
      window.location.href = "mailto:rgift494@gmail.com";
    },
    openExternalLink(url) {
      // Open link in a new tab/window
      window.open(url, "_blank");
    },
    openAnyDesk() {
      // Check device type and open appropriate link
      if (this.isDesktop || this.isLaptop) {
        // For desktop/laptop, download the Windows executable
        window.open("https://download.anydesk.com/AnyDesk.exe", "_blank");
      } else if (this.isTablet || this.isMobile) {
        // For mobile/tablet, open respective app store
        const userAgent = navigator.userAgent.toLowerCase();

        if (/android/.test(userAgent)) {
          // Android - Google Play Store
          window.open(
            "https://play.google.com/store/apps/details?id=com.anydesk.anydeskandroid",
            "_blank"
          );
        } else if (/iphone|ipad|ipod/.test(userAgent)) {
          // iOS - App Store
          window.open(
            "https://apps.apple.com/app/anydesk/id1176131373",
            "_blank"
          );
        } else {
          // Fallback if device type can't be determined
          alert("Please visit your device's app store and search for AnyDesk");
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
// Variables
$footer-bg: #2c2c2ce2;
$text-color: #ffffff;
$hover-color: #f2f2f2;
$icon-size: 16px;

.footer {
  background-image: url("../../../public/images/footerBackGround.jpg");
  background-size: cover;
  color: $text-color;
  z-index: 0;
  background-position-y: bottom;
  position: relative;
  margin-top: 40px;
  .overlay {
    background-color: $footer-bg;
    position: absolute;
    width: 100%;
    height: 100%;
  }

  .footer-container {
    padding: 15px 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    z-index: 2;
    max-width: 1600px;
    margin: auto;

    .footer-center {
      display: flex;
      flex-direction: column;
      .foter-center-continer {
        display: flex;
      }
      h4 {
        font-size: 20px;
        margin-bottom: 10px;
      }

      .footer-link {
        color: $text-color;
        text-decoration: none;
        font-weight: 300;
        cursor: pointer;

        &:hover {
          text-decoration: underline;
          color: $hover-color;
        }
      }

      span {
        margin: 0 5px;
      }

      .footer-badges {
        display: flex;
        align-items: center;
        gap: 16px;
        margin-top: 10px;
        padding: 6px 10px;
        background: rgba(255, 255, 255, 0.08);
        border: 1px solid rgba(255, 255, 255, 0.18);
        border-radius: 8px;
        width: fit-content;

        .secure-badge {
          display: flex;
          align-items: center;
          gap: 5px;
          color: #4caf50;
          font-size: 13px;
          font-weight: 600;
          white-space: nowrap;
        }

        .payment-icons {
          display: flex;
          align-items: center;
          gap: 6px;

          .payment-icon {
            width: 38px;
            height: 25px;
            border-radius: 3px;
          }

          .ssl-badge {
            display: flex;
            align-items: center;
            gap: 3px;
            font-size: 10px;
            font-weight: 700;
            color: #4caf50;
            border: 1px solid #4caf50;
            border-radius: 4px;
            padding: 2px 5px;
          }
        }
      }
    }

    .contact-info {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      font-size: 16px;
      gap: 10px;
      color: $text-color;
      font-weight: 300;
      div & :hover {
        cursor: pointer;
      }
    }
  }
  .dolimo-logo {
    max-width: 90px;
    height: auto;
  }
  .version {
    font-size: 10px;
  }
  img {
    max-width: 60px;
    height: auto;
  }
}
.isMobile.footer,
.isTablet.footer {
  height: unset !important;
}
.isMobile,
.isTablet {
  .foter-center-continer {
    flex-direction: column !important;
  }
  .footer-center {
    flex-direction: column !important;
    align-items: unset !important;
  }
  .footer-container {
    height: unset !important;
    align-items: unset !important;
    flex-direction: column !important;
    gap: 15px;
  }
  .contact-info {
    margin-bottom: 15px;
    flex-direction: column !important;
    align-items: unset !important;
  }
  .more-contact {
    flex-direction: row !important;
  }
}
</style>
